import React, { useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const WebcamCapture = ({ image, setImage, disable }) => {

  const [showModal, setShowModal] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [videoStream, setVideoStream] = useState(null);

  // Start webcam and show preview in modal
  const startWebcam = () => {
    setShowModal(true); // Show the modal with webcam feed
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        setVideoStream(stream); // Store the stream to stop it later
        videoRef.current.srcObject = stream;
      })
      .catch((error) => {
        console.error("Error accessing webcam:", error);
      });
  };

  // Convert data URL to File and update the state
  const dataURLToFile = (dataUrl, fileName) => {

    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1]; // Extract mime type
    const bstr = atob(arr[1]); // Decode base64 string
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n); // Fill the byte array
    }

    return new File([u8arr], fileName, { type: mime }); // Create File object
    
  };

  // Capture image when the user clicks the button
  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the current video frame onto the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Get the captured image as a data URL (JPEG)
    const imageUrl = canvas.toDataURL('image/jpeg');

    // Convert data URL to File
    const imageFile = dataURLToFile(imageUrl, 'captured-image.jpg');

    // Update the state with the image data URL and file
    setImage({
      imageFile, // Set the file object
      imageSrc: imageUrl, // Set the captured image URL (data URL)
      imagepath: null, // No file path, since it's a webcam capture
    });
  };

  // Stop the webcam stream when the modal is closed
  const closeModal = () => {
    if (videoStream) {
      videoStream.getTracks().forEach(track => track.stop());
    }
    setShowModal(false); // Close the modal
  };

  return (
    <div>
      <Button size='sm' className='mt-1' color="primary" onClick={startWebcam} disabled={disable}>Capture Image</Button>

      {/* Modal for showing the webcam feed */}
      <Modal isOpen={showModal} toggle={closeModal}>
        <ModalHeader toggle={closeModal}>Webcam Preview</ModalHeader>
        <ModalBody>
          {/* Webcam Preview */}
          <video ref={videoRef} width="320" height="240" autoPlay />
          {/* Display captured image if available */}
          {image && <img src={image} alt="Captured" width="320" />}
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={captureImage}>Capture</Button>
          <Button color="secondary" onClick={closeModal}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default WebcamCapture;
